import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCoronaengineComponent } from './simple-icons-coronaengine.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCoronaengineComponent ],
    exports:      [ SimpleIconsCoronaengineComponent ],
    bootstrap:    []
})
export class SimpleIconsCoronaengineModule {}
